import React from 'react';

const locations = [
  {
    id: 1,
    city: "Pune, India",
    address:
      "Floor 11, Platinum Capital, N Main Rd, Koregaon Park Annexe, Mundhwa, Pune, Maharashtra 411036",
    image: "/assets/contact/c1.png",
    layout: "image-top",
  },
  {
    id: 2,
    city: "Dubai, UAE",
    address:
      "45th floor, The One Tower, Sheikh Zayed Rd, Barsha Heights, Dubai - UAE.",
    image: "/assets/contact/c2.png",
    layout: "text-top",
  },
  {
    id: 3,
    city: "Indore, India",
    address:
      "2nd Floor, Smart Seed, AICTSL Campus, Navratan Bagh, Indore, Madhya Pradesh 452001",
    image: "/assets/contact/c3.png",
    layout: "image-top",
  },
  {
    id: 4,
    city: "Bengaluru, India",
    address:
      "Prestige Meridian 1, M.G. Road, Bengaluru, Karnataka 560001.",
    image: "/assets/contact/c4.png",
    layout: "text-top",
  },
  {
    id: 5,
    city: "Hyderabad, India",
    address:
      "Krishe Emerald, Ground Floor, Kondapur Main Road, Kondapur, Laxmi Cyber City, Whitefields, Kondapur, Hyderabad, Telangana 500081, India",
    image: "/assets/contact/c5.png",
    layout: "image-top",
  },
  {
    id: 6,
    city: "Dublin, Ireland",
    address:
      "The Greenway, St Stephen's Green, Dublin 2, Ireland.",
    image: "/assets/contact/c6.png",
    layout: "text-top",
  },
];

const GlobalPresence = () => {
  return (
    <section className="w-full bg-white pb-16 lg:pb-24">
      <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
        <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mb-12 lg:mb-16 text-center">
          Global Presence
        </h2>
        {/* <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 w-full">
          {locations.map((loc) => (
            <div
              key={loc.id}
              className={`flex w-full h-[500px] lg:h-[600px] ${loc.layout === 'text-top' ? 'flex-col lg:flex-col-reverse' : 'flex-col'
                }`}
            >
              <div className="w-full h-1/2 overflow-hidden relative group">
                <img
                  src={loc.image}
                  alt={loc.city}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-all duration-500"></div>
              </div>
              <div className="w-full h-1/2 bg-[#F4F6F9] relative group overflow-hidden flex flex-col justify-center px-6 lg:px-8 transition-all duration-300 hover:bg-[#EEF1F6]">
                <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2 transition-all duration-300 group-hover:-translate-y-2">
                  {loc.city}
                </h3>
                <div className="max-h-0 opacity-0 group-hover:max-h-[100px] group-hover:opacity-100 transition-all duration-500 ease-in-out overflow-hidden">
                  <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] leading-relaxed font-graphik">
                    {loc.address}
                  </p>
                </div>
                <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
              </div>
            </div>
          ))}
        </div> */}
            <div
          className="
            grid
            grid-cols-1
            sm:grid-cols-2
            lg:grid-cols-3
            gap-x-5
            sm:gap-x-6
            lg:gap-x-5
            gap-y-[68px]
            lg:gap-y-[68px]
          "
        >
          {locations.map((location) => (
            <div
              key={location.id}
              className="
                group
                relative
                w-full
                h-[390px]
                sm:h-[400px]
                lg:h-[390px]
                cursor-pointer
              "
            >
              {/* Main Border Card */}
              <div
                className="
                  absolute
                  left-0
                  right-0
                  bottom-0
                  h-[292px]
                  sm:h-[300px]
                  lg:h-[292px]
                  border
                  border-[#C9D3DF]
                  bg-white
                  transition-all
                  duration-300
                  group-hover:border-[#BFCBD8]
                "
              >
         
<div
  className="
    absolute
    inset-x-0
    top-0
    h-full
    flex
    flex-col
    items-start
    justify-start
    text-left
    px-6
    sm:px-7
    lg:px-8
    pt-[125px]
  "
>
  {/* City */}
  <h3
    className="
      text-[#073D70]
      text-[21px]
      sm:text-[21px]
      lg:text-[20px]
      font-[600]
      font-sora
      leading-tight
      mb-4
      transition-transform
      duration-300
      group-hover:-translate-y-1
    "
  >
    {location.city}
  </h3>

  {/* Address */}
  <p
    className="
      text-[#536487]
      text-[14px]
      sm:text-[15px]
      lg:text-[15px]
      font-[400]
      font-graphik
      leading-[1.55]
      max-w-[330px]
    "
  >
    {location.address}
  </p>
</div>

                {/* Bottom Hover Line */}
                <div
                  className="
                    absolute
                    left-[-1px]
                    right-[-1px]
                    bottom-[-1px]
                    h-[4px]
                    bg-[#073D70]
                    group-hover:bg-[#ED6800]
                    transition-colors
                    duration-300
                  "
                />
              </div>

              {/* Image */}
              <div
                className="
                  absolute
                  z-10
                  top-0
                  left-1/2
                  -translate-x-1/2
                  w-[78%]
                  sm:w-[76%]
                  lg:w-[80%]
                  h-[198px]
                  sm:h-[198px]
                  lg:h-[198px]
                  overflow-hidden
                "
              >
                <img
                  src={location.image}
                  alt={location.city}
                  className="
                    w-full
                    h-full
                    object-cover
                    transition-transform
                    duration-700
                    ease-out
                    group-hover:scale-[1.04]
                  "
                />

                {/* Image Overlay */}
                <div
                  className="
                    absolute
                    inset-0
                    bg-black/5
                    group-hover:bg-transparent
                    transition-all
                    duration-500
                  "
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GlobalPresence;